// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"439":"c005bba6","453":"8772224c","793":"242570de","860":"1795c22d","882":"38d822a7"}[chunkId] + ".chunk.js";
};